
import { useState } from "react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { useToast } from "@/hooks/use-toast";
import { supabase } from "@/integrations/supabase/client";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";

type EmailFormProps = {
  initialEmail: string;
};

export const EmailForm = ({ initialEmail }: EmailFormProps) => {
  const [newEmail, setNewEmail] = useState(initialEmail);
  const { toast } = useToast();
  const navigate = useNavigate();
  const { t } = useTranslation();

  const updateEmail = async (e: React.FormEvent) => {
    e.preventDefault();
    try {
      const { error } = await supabase.auth.updateUser({ email: newEmail });
      
      if (error) throw error;

      toast({
        title: t("profile.messages.success"),
        description: t("profile.messages.emailConfirmationSent"),
      });
      
      navigate("/");
    } catch (error: any) {
      toast({
        title: t("profile.messages.error"),
        description: error.message,
        variant: "destructive",
      });
    }
  };

  return (
    <form onSubmit={updateEmail} className="space-y-4">
      <div className="space-y-2">
        <Label htmlFor="new-email">{t("profile.form.newEmail")}</Label>
        <Input
          id="new-email"
          type="email"
          value={newEmail}
          onChange={(e) => setNewEmail(e.target.value)}
        />
      </div>
      <Button type="submit">
        {t("profile.form.updateEmail")}
      </Button>
    </form>
  );
};
